import React from 'react';
import { useFiltersContext } from '@/finsight/application/FiltersContext';
import IconFiltering from '@dealroadshow/uikit/core/components/Icon/IconFiltering';
import Input from '@dealroadshow/uikit/core/components/Input';
import { useTraceTableContext } from '@/finsight/application/Trace/TraceTableContext';
import useGetTracePayload from '@/finsight/application/Trace/useGetTracePayload';

import styles from '@/Framework/UI/Organisms/FinalForm/Fields/SearchInput/search-input.scss';

const SearchInput = (props) => {
  const config = {
    name: 'searchTrades',
    isNarrow: true,
    placeholder: 'Filter by Bond, Issuer or CUSIP',
  };
  const {
    onSearch,
    params: { search },
  } = useFiltersContext();
  const { debouncedGetTrades } = useTraceTableContext();
  const { getPayload } = useGetTracePayload();

  const onChange = ({ target: { value } }) => {
    onSearch(value);
    debouncedGetTrades(getPayload({
      params: {
        search: value,
        page: 1,
      },
    }));
  };

  return (
    <Input
      { ...props }
      { ...config }
      formFieldClassName={ styles.searchInput }
      icon={ IconFiltering }
      value={ search }
      onChange={ onChange }
      dataTest="formSearchInput"
    />
  );
};

export default SearchInput;
